import React from 'react';
import {
  SendableSurveyItem,
  SendableSurveyItemData,
} from './SendableSurveyItem';
import styles from '@/styles/components/sendable-survey-stack/SendableSurveyStack.module.css';
import docs from '@/assets/docs.svg';
import { InfoTooltip } from 'components/InfoTooltip';

export interface SendableSurveyStackData {
  items: SendableSurveyItemData[];
  count: number;
}
export const SendableSurveyStack: React.FC<SendableSurveyStackData> = props => {
  return (
    <div className={styles.stackWrapper}>
      <div className={styles.totalCountContainer}>
        <div className={styles.info}>
          <span>TOTAL SENDABLE PANEL SURVEYS</span>
          <InfoTooltip id="sendable-panel">
            <span className={styles.tooltipMainText}>
              This indicates the <b>number of surveys you have purchased</b> and
              are able to send.
            </span>
            <span className={styles.tooltipText}>
              *You can only send surveys that are fully complete — your fully
              completed surveys will populate to the right{'—>'}.
            </span>
            <span className={styles.tooltipText}>
              **You can send surveys you built from scratch, surveys you chose
              from our template library (with semi-editable features), or copy &
              edit one of your existing surveys.
            </span>
          </InfoTooltip>
        </div>
        <div className={styles.totalCount}>
          <span>{props.count}</span>
        </div>
      </div>
      <div className={styles.stack}>
        <div className={styles.info}>
          <span>READY TO SEND PANEL SURVEYS</span>
          <InfoTooltip id="ready-to-send">
            <span className={styles.tooltipMainTextSmall}>
              There are surveys that you have{' '}
              <b>already created and completed</b> — meaning that all the survey
              {"'"}s required fields have been filled in, and now the survey is
              in finished, sendable state.
            </span>
            <span className={styles.tooltipTextSmall}>
              *But don{"'"}t worry you can always continue to edit these surveys
              up until you hit the send button.
            </span>
          </InfoTooltip>
        </div>
        <div className={styles.stackContainer}>
          {props.items.length === 0 && (
            <div className={styles.emptyPlaceholderContainer}>
              <img src={docs} alt="docs" className={styles.emptyImg}></img>
              <span className={styles.emptyText}>
                {
                  "You don't have any ready-to-send surveys built yet. Start building!"
                }
              </span>
            </div>
          )}
          {props.items.map((item, index) => (
            <SendableSurveyItem key={index} {...item}></SendableSurveyItem>
          ))}
        </div>
      </div>
    </div>
  );
};
